import _createClass from "/Users/shing/Person/website/retro/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/shing/Person/website/retro/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var IEvents = /*#__PURE__*/_createClass(function IEvents() {
  _classCallCheck(this, IEvents);
});